<template>
    <rkm-area
        no-margin-top
        title="Problemas e/ou condições avaliados neste atendimento"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.avaliacao.problemasCondicoes"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col :cols="item.situacao ? 5 : 6">
                                <Item
                                    :get-value="() => `${item.ciap.codigo} - ${item.ciap.descricao}`"
                                    label="CIAP 2"
                                />
                            </rkm-col>

                            <rkm-col :cols="item.situacao ? 5 : 6">
                                <Item
                                    :get-value="() => `${item.cid.codigo} - ${item.cid.nome}`"
                                    label="CID 10"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="item.situacao"
                                cols="2"
                            >
                                <Item
                                    :append-text="item.resolvidoAutomaticamente ? '(automático)' : null"
                                    :get-value="() => item.situacao.nome"
                                    label="Situação"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="item.situacao">
                            <rkm-col cols="5">
                                <Item
                                    :get-value="() => item.inicio"
                                    label="Início"
                                />
                            </rkm-col>

                            <rkm-col cols="5">
                                <Item
                                    :get-value="() => item.fim"
                                    label="Fim"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template #collapse="{item}">
                        <rkm-row class="p-2">
                            <rkm-col>
                                <Item :get-value="() => item.observacao" />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>